import refundPaymentTemplate from './refundPayments.template.html';

/*******************************************************************************
 * Component */
/**
 * @ngdoc   component
 * @module  csm.books.com.returnItems
 * @name    csm.books.com.returnItems.component:refundPayments
 * @description
 *
 *******************************************************************************/
export const refundPaymentsComponent = {
  controller: Controller,
  template: refundPaymentTemplate,
  bindings: {
    amounts: '=',
    entities: '<',
    bankAccounts: '<',
    receivedFromId: '<',
    fundsEntity: '=',
    checkAccountId: '=',
    checkEntity: '=',
    checkHandwritten: '=',
    checkNumber: '=',
    uiFlags: '<',
    hasProcessor: '<'
  }
};

/*******************************************************************************
 * Controller */
/**
 * @ngdoc   controller
 * @module  csm.books.com.returnItems
 * @name    csm.books.com.returnItems.controller:Controller
 * @description
 * Controls the data flow for the component
 *******************************************************************************/
/* @ngInject */ function Controller(
  $injector,
  $rootScope,
  Alert,
  Tools,
  SERVER
) {
  /** Self Reference */ var $ctrl = this;
  var svcs = { $ctrl: $ctrl };

  var mFunds = 0;
  $ctrl.offlineCardRecordCollaspse = true;

  $ctrl.checkRefundAmount = $injector.invoke(checkRefundAmount, null, svcs);
  $ctrl.onEntity = $injector.invoke(onEntity, null, svcs);
  $ctrl.onPayable = $injector.invoke(onPayable, null, svcs);

  /*---------------*/
  /* SWF/App Flags */
  /*---------------*/
  /** Restrict Entities. */ var mRestrictEntities =
    SERVER.appFlags.restrictEntities;

  Object.defineProperties($ctrl, {
    disableOnFunds: {
      get: () => !$ctrl.uiFlags.hasFundsAccount || $ctrl.uiFlags.hasFundsReturn
    },
    studentFundsTooltip: {
      get: () =>
        $ctrl.uiFlags.hasFundsReturn
          ? 'Student Funds cannot be returned to Student Funds.'
          : 'Go to Account Admin and set the Student Funds refund account to use this feature'
    },
    writeCheckTotal: {
      get: function () {
        return ($ctrl.amounts.check = $ctrl.uiFlags.hasClearingAccount
          ? Tools.roundMoney(
              $ctrl.amounts.totalDue -
                $ctrl.amounts.funds -
                $ctrl.amounts.cash -
                $ctrl.amounts.journal
            )
          : 0);
      }
    }
  });

  $ctrl.needsAccount = function (account) {
    return !$ctrl.uiFlags.hasFundsAccount
      ? null
      : 'Go to Account Admin and set the "{0} Account" special account to use this feature'.format(
          account
        );
  };

  /*****************************************************************************
   * checkRefundAmount */
  /**
   * Event handler for checking that the total amount entered between the On
   * Account and Cash fields is not greater than the total Refund Amount. This is
   * checked from the blur of the two fields mentioned.
   *****************************************************************************/
  /* @ngInject */ function checkRefundAmount($ctrl, Alert) {
    return function ($event) {
      if ($ctrl.writeCheckTotal < 0) {
        var alertObj = {
          title: 'Invalid Refund Amount',
          text: 'The refunded amount being returned is more than what is due.',
          type: Alert.TYPE_ERROR
        };

        /*------------------------------------*/
        /* After displaying the alert, move   */
        /* focus back to the offending field. */
        /*------------------------------------*/
        Alert.show(alertObj).then(function () {
          $event.currentTarget.focus();
        });
      }
    };
  }

  /*****************************************************************************
   * onChanges */
  /**
   * If any of the one-way bindings is changed, update the selected entity in the
   * two input fields.
   *****************************************************************************/
  $ctrl.$onChanges = function (changes) {
    if (!$ctrl.entities) return;

    var receivedFrom = $ctrl.entities
      .filter(function (entity) {
        return entity.id == $ctrl.receivedFromId;
      })
      .shift();
    $ctrl.fundsEntity = receivedFrom;
    $ctrl.checkEntity = receivedFrom;
  };

  /*****************************************************************************
   * onEntity */
  /**
   * From setting the Entity for the On Account field, get the funds available to
   * the entity.
   *
   * @param  entity
   *****************************************************************************/
  /* @ngInject */ function onEntity($ctrl, ReturnsService) {
    return function (entity) {
      if (!entity) return null;

      return ReturnsService.getFunds(entity.id).then(function (resp) {
        entity.funds = resp;
        return entity;
      });
    };
  }

  /*****************************************************************************
   * onInit */
  /**
   * When the component is initialized, create the property accessors to disable
   * the additional fields until the amounts for those sections have a value.
   *****************************************************************************/
  $ctrl.$onInit = function () {
    $ctrl.amounts.journal = 0;
    $ctrl.amounts.cash = 0;

    Object.defineProperty($ctrl.amounts, 'funds', {
      get: function () {
        return mFunds;
      },
      set: function (value) {
        mFunds = Math.min(value, $ctrl.amounts.totalDue);
      }
    });

    Object.defineProperty($ctrl, 'disableCheck', {
      get: function () {
        return $ctrl.amounts.check <= 0;
      }
    });
    Object.defineProperty($ctrl, 'disableFunds', {
      get: function () {
        return $ctrl.amounts.funds <= 0 || $ctrl.fundsEntity;
      }
    });
  };

  /*****************************************************************************
   * onPayable */
  /**
   * Fires when the 'Paid To' field receives focus or loses focus. If the model
   * is not an object and is not empty, then the user has not selected an
   * existing entity. Display the entity maker with the user's entry.
   *
   * @param   $event   Event object
   *****************************************************************************/
  /* @ngInject */ function onPayable(
    $ctrl,
    Alert,
    BooksSvc,
    BusyScreen,
    EntityMaker,
    Tools
  ) {
    var mSavedEntity;
    var mEntityMakerActive = false;

    /*---------------------------------------*/
    /* Resolve handler for the Entity Maker. */
    /*---------------------------------------*/
    var resolve = function (result) {
      BusyScreen.setBusy(true);

      /*-------------------------------------*/
      /* Build a new entity object with      */
      /* result from EntityMaker and use it. */
      /*-------------------------------------*/
      if (result.added)
        return BooksSvc.getAddressEntityListItem(result.entity.id).then(
          function (resp) {
            $ctrl.entities.push(resp.data.entity);
            $ctrl.checkEntity = resp.data.entity;
          }
        );
    };

    return function ($event) {
      /*--------------------------------------------*/
      /* Save the current entity reference on focus */
      /*--------------------------------------------*/
      if ($event.type == 'focus') {
        mSavedEntity = $ctrl.checkEntity;
        return;
      }

      /*----------------------------------------------------------------*/
      /* The focus is still on the field, do nothing. This will         */
      /* usually be from the selection of an entity with the type ahead */
      /*----------------------------------------------------------------*/
      if (document.activeElement == document.getElementById('paidTo')) return;

      /*----------------------------------------------*/
      /* If the model is an object, there has been an */
      /* entity selection and needs to be processed   */
      /*----------------------------------------------*/
      if (typeof $ctrl.checkEntity == 'object') return;

      /*----------------------------------*/
      /* If the model is an empty string, */
      /* then the field is being cleared. */
      /*----------------------------------*/
      if (Tools.isEmpty($ctrl.checkEntity)) {
        $ctrl.checkEntity = null;
        return;
      } else if (!mRestrictEntities) {
        /*-------------------------------------------------------------*/
        /* Otherwise, the model is text corresponding to the unmatched */
        /* payable to. Use the Entity Maker to process the input       */
        /*-------------------------------------------------------------*/
        mEntityMakerActive = true;

        EntityMaker.newEntity($ctrl.checkEntity)
          .then(resolve, function () {
            $event.target.focus();
          })
          .finally(function () {
            BusyScreen.setBusy(false);
            mEntityMakerActive = false;
          });
      } else {
        $event.target.value = '';
        Alert.info('You must select an existing entity.', 'Returns');
      }
    };
  }
}
